import * as React from "react";
import CclDrawer from "../../../components/common/cclDrawer/cclDrawer";
import { Box, Stack, TextField } from "@mui/material";
import CclLoadingButton from "../../../components/common/cclButtons/cclLoadingButton";
import CclButton from "../../../components/common/cclButtons/cclButton";
import CclDrawerActionBar from "../../../components/common/cclDrawer/cclDrawerActionBar";
import { EventDocument } from "../../../services/types/search.service.types";
import useLogAccessEvent from "../../../hooks/useLogAccessEvent";
import { GridFilterModel } from "@mui/x-data-grid-pro";

interface SessionsClientSearchControlProps {
    onSearchResults: (results: GridFilterModel) => void;
    open: boolean;
    data: EventDocument[] | undefined;
    pastSearch: SessionsClientSearchData | undefined;
    updatePastSearch: (data: SessionsClientSearchData | undefined) => void;
    onReset: () => void;
    onClose: () => void;
}

export interface SessionsClientSearchData {
    title: string;
    customer: string;
}

const SessionsClientSearchControl: React.FC<SessionsClientSearchControlProps> = (props) => {
    const [customer, setCustomer] = React.useState<string>(props.pastSearch?.customer ?? "");
    const [title, setTitle] = React.useState<string>(props.pastSearch?.title ?? "");

    const { logEvent } = useLogAccessEvent();

    const executeSearch = async () => {
        let filterModel: { items: { columnField: string; operatorValue: string; value: string }[] } = {
            items: []
        }
        
        if (customer) {
            filterModel.items.push(
                {
                    columnField: "clientOrganization",
                    operatorValue: "contains",
                    value: customer,
                }
            );
        }
        if (title) {
            filterModel.items.push(
                {
                    columnField: "title",
                    operatorValue: "contains",
                    value: title,
                }
            );
        }

        logEvent("SessionSearchExecuted", null);
        props.updatePastSearch({ customer, title });
        props.onSearchResults(filterModel);
    };

    const resetClientSearch = () => {
        setCustomer("");
        setTitle("");
        props.updatePastSearch(undefined);
        props.onReset();
        props.onClose();
    };

    return (
        <CclDrawer title={"Search"} open={props.open} onClose={props.onClose} width="standard">
            <Box sx={{ overflow: "hidden", height: 1 }}>
                <Stack spacing={4} sx={{ overflow: "auto", padding: 2 }}>
                    <TextField
                        fullWidth
                        label="Title"
                        variant="outlined"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="Customer"
                        variant="outlined"
                        value={customer}
                        onChange={(e) => setCustomer(e.target.value)}
                    />
                </Stack>

                <CclDrawerActionBar>
                    <CclLoadingButton
                        loading={false}
                        onClick={executeSearch}
                        disabled={false}
                        sx={{ m: 1 }}
                        mode={"primary"}
                    >
                        Search
                    </CclLoadingButton>
                    <CclButton sx={{ m: 1 }} onClick={props.onClose} mode={"secondary"}>
                        Close
                    </CclButton>
                    <CclButton
                        sx={{ float: "right", m: 1, ml: "auto" }}
                        onClick={resetClientSearch}
                        mode={"secondary"}
                    >
                        Reset
                    </CclButton>
                </CclDrawerActionBar>
            </Box>
        </CclDrawer>
    );
};

export default SessionsClientSearchControl;
